/** Oregon-only SPS adder: dollars per watt DC (same units as Portland/sustainable adder in PropView). */
export const OR_SPS_ADDER_PER_WATT = 0.2;

export function getOrSpsAdderRatePerWatt(state) {
  return state === "Oregon" ? OR_SPS_ADDER_PER_WATT : 0;
}

/** Total cash adder for OR SPS (`systemSize` is DC watts, same as PropView `systemSize`). */
export function getOrSpsAdderTotalCash(state, systemSizeWatts) {
  return getOrSpsAdderRatePerWatt(state) * (+systemSizeWatts || 0);
}

/**
 * Util function to determine if the PowerWall should be rendered
 * - The territories list my not be complete, thus we default to true
 *
 * @param {string} territory - The territory of the user
 */
export function shouldRenderPowerWall(territory) {
  const territories = {
    Albuquerque: false,
    Oklahoma: false,
    Ohio: false,
    Richmond: true,
    "Virgina Beach": false,
    Nova: false,
    Navada: false,
    Buda: true,
    Chicago: true,
    Springs: true,
    Dallas: true,
    Denver: true,
    Houston: true,
    Oregon: true,
    Utah: true,
  };

  // return territories[territory] ?? true;
  return true;
}

/**
 * Util function to get the PowerWall options based on the customer's state
 *
 * @param {string} state - The state of the user
 * @param {boolean} ppa - Whether the user is on a PPA
 * @returns {Array} An array of options for the PowerWall
 */
export function getPowerWallOptions(state) {
  if (state === "Illinois") {
    return Array.from({ length: 3 }, (_, i) => ({
      value: 2950 + i * 1000,
      label: `$${2950 + i * 1000}`,
    }));
  }

  if (state === "Texas") {
    // $7,000 / $8,000 / $9,000 options for Texas
    return Array.from({ length: 3 }, (_, i) => ({
      value: 7000 + i * 1000,
      label: `$${7000 + i * 1000}`,
    }));
  }

  return Array.from({ length: 3 }, (_, i) => ({
    value: 12500 + i * 1500,
    label: `$${12500 + i * 1500}`,
  }));
}

/**
 * Cash price per Tesla Powerwall expansion pack by state (before dealer fee).
 */
export function getExpansionPackCashPrice(state) {
  if (state === "Illinois") return 2950;
  if (state === "Texas") return 7000;
  return 9500;
}

export const getPowerwallQuantityOptions = (systemSizeAC) => {
  return [
    ...(systemSizeAC < 10 ? [{ label: "1", value: 1 }] : []),
    { label: "2", value: 2 },
  ];
};

export const getPowerwallExpansionPackOptions = (systemSizeAC, battery10) => {
  return [
    ...(systemSizeAC < 7.6 ? [{ label: "0", value: 0 }] : []), // Not being used
    ...Array.from({ length: (+battery10 - 10) * 3 }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1,
    })),
  ];
};


// // is props.customer.state == "Illinois" or "illinois" or "IL" or "Il"???
// // Does baseAmount already have dealer fee?
// export const getBatteryAmounts = (state, battery10, dealerFee, baseAmount) => {
//   let quantity = 0;
//   let basePrice = 0;
//   let basePriceAdditional = 0;
//   let cashPriceFirst = 0;
//   let cashPriceAdditional = 0;
//   let type = "";

//   if (battery10 >= 11 && battery10 < 20) {
//     quantity = battery10 - 10;
//     type = "Battery - Tesla Powerwall 3";

//     if (state === "Illinois") {
//       basePrice = 4650;
//     } else if (state === "Texas") {
//       basePrice = 11000;
//     } else {
//       basePrice = 12500;
//     }

//     cashPriceFirst = baseAmount ? Math.round(baseAmount) : basePrice;
//     cashPriceAdditional = basePrice;
//   } else if (battery10 >= 21 && battery10 <= 30) {
//     quantity = battery10 - 20;
//     type = "Battery - Enphase 10c";

//     if (state === "Illinois") {
//       basePrice = 13000;
//       basePriceAdditional = 10000;
//     } else {
//       basePrice = 16000;
//       basePriceAdditional = 13000;
//     }

//     cashPriceFirst = baseAmount ? Math.round(baseAmount) : basePrice;
//     cashPriceAdditional = basePriceAdditional;
//   }

//   const totalCashPrice = cashPriceFirst + cashPriceAdditional * (quantity - 1);

//   const result =  {
//     type,
//     cashPriceFirst,
//     cashPriceAdditional,
//     priceWithDealerFeeFirst: cashPriceFirst / +dealerFee,
//     priceWithDealerFeeAdditional: cashPriceAdditional / +dealerFee,
//     totalCashPrice,
//     totalPrice: totalCashPrice / +dealerFee,
//   };

//   console.log("result", result);

//   return result;
// };

export const getEnphase10cFirstBatteryAmount = (state) => {
  return state === "Illinois" ? 13000 : 16000;
};

export const getEnphase10cAdditionalBatteryAmount = (state) => {
  return state === "Illinois" ? 10000 : 13000;
};

export const getEnphase10cAmount = (battery10, state) => {
  const quantity = +battery10 - 20;
  const baseAmount = state === "Illinois" ? 13000 : 16000;
  const additionalAmount = state === "Illinois" ? 10000 : 13000;

  return baseAmount + additionalAmount * (quantity - 1);
};

export const getTeslaBatteryAmount = (baseAmount, battery10, state) => {
  const quantity = +battery10 - 10;
  const additionalAmount =
    state === "Illinois" || state === "Texas" ? baseAmount : 12500;

  return baseAmount + additionalAmount * (quantity - 1);
};
